export interface CashQuantities {
  settled_open_quantity?: number
  unsettled_open_quantity?: number
  moment_reserved_quantity?: number
  open_quantity?: number
}

export function cashLotAvailableQuantity(lot: CashQuantities): number {
  const components =
    (lot.settled_open_quantity ?? 0) +
    (lot.unsettled_open_quantity ?? 0) +
    (lot.moment_reserved_quantity ?? 0)

  return components
}

// Total cash incl. the unsettled post-trade residual (not settled-only).
export function calculateTotalAccountCash(
  cash: readonly CashQuantities[] | null | undefined,
): number {
  if (!cash) return 0
  return cash.reduce<number>(
    (sum, lot) => sum + (lot ? cashLotAvailableQuantity(lot) : 0),
    0,
  )
}

interface SleeveScopedCash extends CashQuantities {
  sleeve_id?: string | null
}

// Sums the cash belonging to a single sleeve. Pre-sleeve-cash payloads carry no
// sleeve_id, so they sum to the whole account under the single-account
// assumption (PORT-2902).
export function calculateSleeveCash(
  cash: readonly SleeveScopedCash[] | null | undefined,
  sleeveId: string,
): number {
  if (!cash?.length) return 0
  const hasSleeveScopedCash = cash.some((entry) => entry.sleeve_id != null)
  if (!hasSleeveScopedCash) return calculateTotalAccountCash(cash)
  return calculateTotalAccountCash(
    cash.filter((entry) => entry.sleeve_id === sleeveId),
  )
}
